export const theme = {
  colors: {
    primary: '#151725',
    secondary: '#AAABB9',
    white: '#FFFFFF',
    background: '#F5F6FA',
    active: '#0052CC',
    focus: 'tomato',
    logo: '#1D1F36',
    logospan: '#1D1F36',
    logonote: '#1D1F36',
    red: '#F33F33',
    green: '#2EB052',
    yellow: '#FFD646',
    greyDark: '#7B7B89',
    greyLight: '#DBDCE6',
    btnColor: '#314EB6',
    btnColorHover: '#2269D2',
    btnColorActive: '#1656B6',
  },

  fonts: {
    main: 'Inter, sans-serif',
    logo: 'Red Hat Display, sans-serif',
  },

  fontSizes: {
    xxs: '8px',
    logonote: '9px',
    xs: '12px',
    s: '14px',
    m: '18px',
    l: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '56px',
  },

  fontWeights: {
    normal: 400,
    bold: 600,
  },

  lineHeights: {
    normal: 'normal',
    section: 1.2,
    title: 1.3,
    button: 1.33,
    price: 1.4,
  },

  shadow: {
    normal: '3px 1px 40px 0px rgba(187, 194, 221, 0.10)',
    medium: '7px 13px 14px rgba(116, 177, 232, 0.24)',
  },

  borders: {
    none: 'none',
    normal: '1px solid',
    medium: '2px solid',
  },

  media: {
    mobile: '(min-width: 320px)',
    bigMobile: '(min-width: 480px)',
    tablet: '(min-width: 768px)',
    landscapeTablet: '(min-width: 1000px)',
    desktop: '(min-width: 1280px)',
  },
};
